import { call, getContext, put, select, takeLatest } from 'redux-saga/effects';
import { setError } from '../error/errorActions';
import {
  GET_PARTICIPANTS,
  UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL,
  UPDATE_CURRENT_PARTICIPANT_BILLABLE_ENTITY,
  UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS,
} from './participantsConstants';
import { participantsGatewayInterface } from './participantsGatewayInterface';
import { ParticipantsActions } from './participantsActions';
import { EParticipant } from '../../models/entities/participant/participant';
import { selectCurrentParticipantId } from '../../../module/participant/participant.slice';

function* getParticipants() {
  try {
    const participantsGatewayInterface: participantsGatewayInterface = yield getContext('participantsGatewayContext');
    const participants: EParticipant[] = yield call(participantsGatewayInterface.getParticipantsByJwt);
    yield put(ParticipantsActions.setParticipants(participants));
  } catch (error: any) {
    yield put(setError({ status: error.response && error.response.status }));
    console.error(error);
  }
}

function* updateCurrentParticipantDsoDetails(action: any) {
  try {
    const { dsoDetails } = action.payload;
    const participantId: number = yield select(selectCurrentParticipantId);
    const participantsGateway: participantsGatewayInterface = yield getContext('participantsGatewayContext');
    yield call(participantsGateway.updateDsoDetails, { dsoDetails: dsoDetails, participantId: participantId });
  } catch (error: any) {
    yield put(setError({ status: error.response && error.response.status }));
    console.error(error);
  }
}

function* updateCurrentParticipantBillingDetail(action: any) {
  try {
    const { billingDetail } = action.payload;
    const participantId: number = yield select(selectCurrentParticipantId);
    const participantsGateway: participantsGatewayInterface = yield getContext('participantsGatewayContext');
    yield call(participantsGateway.updateBillingDetail, { billingDetail: billingDetail, participantId: participantId });
  } catch (error: any) {
    yield put(setError({ status: error.response && error.response.status }));
    console.error(error);
  }
}

function* updateCurrentParticipantBillableEntity(action: any) {
  try {
    const { billableEntity } = action.payload;
    const participantId: number = yield select(selectCurrentParticipantId);
    const participantsGateway: participantsGatewayInterface = yield getContext('participantsGatewayContext');
    yield call(participantsGateway.updateBillableEntity, {
      billableEntity: billableEntity,
      participantId: participantId,
    });
  } catch (error: any) {
    yield put(setError({ status: error.response && error.response.status }));
    console.error(error);
  }
}

export function* updateCurrentParticipantDsoDetailsSaga() {
  yield takeLatest(UPDATE_CURRENT_PARTICIPANT_DSO_DETAILS, updateCurrentParticipantDsoDetails);
}
export function* updateCurrentParticipantBillingDetailSaga() {
  yield takeLatest(UPDATE_CURRENT_PARTICIPANT_BILLING_DETAIL, updateCurrentParticipantBillingDetail);
}
export function* updateCurrentParticipantBillableEntitySaga() {
  yield takeLatest(UPDATE_CURRENT_PARTICIPANT_BILLABLE_ENTITY, updateCurrentParticipantBillableEntity);
}
export function* getParticipantsSaga() {
  yield takeLatest(GET_PARTICIPANTS, getParticipants);
}

const participantSagas = [
  getParticipantsSaga,
  updateCurrentParticipantDsoDetailsSaga,
  updateCurrentParticipantBillingDetailSaga,
  updateCurrentParticipantBillableEntitySaga,
];

export default participantSagas;
